import { useTranslation } from "react-i18next";
import { AppButton } from "@/components/ui";
import { CheckCircle, ChevronLeft } from "lucide-react";

interface MagicLinkSentProps {
  email: string;
  onBack: () => void;
}

export function MagicLinkSent({
  email,
  onBack,
}: MagicLinkSentProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-8 text-center">
      <div className="flex w-20 h-20 items-center justify-center rounded-3xl bg-success/10 shadow-inner">
        <CheckCircle className="w-10 h-10 text-success" />
      </div>
      <div className="space-y-4">
        <h2
          className="text-3xl font-bold text-foreground"
          aria-live="polite"
        >
          {t("auth.magicLink.sent.title")}
        </h2>
        <p className="text-lg text-foreground-secondary">
          {t("auth.magicLink.sent.message", { email })}
        </p>
      </div>
      <AppButton
        variant="ghost"
        onPress={onBack}
        className="text-sm font-bold text-success hover:underline transition-colors flex items-center gap-2"
      >
        <ChevronLeft className="w-4 h-4" />
        {t("auth.magicLink.sent.back")}
      </AppButton>
    </div>
  );
}
